<template>
  <v-container class="max-width py-0">
    <v-row  style="max-height:226px;" IMAGE DIV>
      <v-col cols="12" class="pa-0 ma-0">
        <v-pagination
          v-if="resourceSettings.pagination && resource && resource.last_page"
          v-model="resource.current_page"
          class="my-0"
          :total-visible="7"
          color="primary"
          @input="pageByNumber"
          :length="resource.last_page"
        >
        </v-pagination>
      </v-col>
      <v-col cols="12" class="pa-0 ma-0 text-center">
        <v-btn color="success" @click="loadResource()" x-small>{{ i18n.reload }}</v-btn>
        <v-btn v-if="allowCreate" color="primary" class="mr-2" @click.prevent="createResource" x-small>{{ i18n.new }}</v-btn>
      </v-col>
    </v-row>
    

  </v-container>
</template>

<script>
export default {
  props:['resourceSettings', 'resource'],
  methods:{
    loadResource() {
      this.$emit('loadResource')
    },
    createResource() {
      this.$emit('createResource')
    },
    pageByNumber(n) {
      this.$emit('pageByNumber', n)
    }
  },
  computed:{
    allowCreate(){
      if(this.resourceSettings) {
        if( this.resourceSettings.create && !this.resourceSettings.master_create) {
          return true
        } 
        if( this.resourceSettings.createResource && !this.resourceSettings.master_create) {
          return true
        } 
        if(this.resourceSettings.master_create && this.master) {
          return true
        }
      }
      return false;
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    master() {
      return this.$store.state.user.role == 'master';
    },
  }
}
</script>

<style>

</style>